import styles from './Logo.module.css'
import {logo} from "../../assets/icons/icons.ts";

export const Logo: React.FC = () => {

    return (
        <a className={styles.logo} href="/">
            <img className={styles.image} src={logo} alt='Логотип'/>
        </a>
    );
};
